export default function ProtectedRoute({ children }: any) { return children; }
